import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import NavGroup from "./comp/NavGroup";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { setMenusData } from "../../reducers/sidebarSlice";
import { useLocation, useNavigate } from "react-router";

export default function Sidebar() {
  const [menus, setMenus] = useState<any>([]);
  const sideBarShow = useAppSelector((state) => state.layout.sideBarShow);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [menuActive, setMenuActive] = useState<any>();

  useEffect(() => {
    function convertMenu(dataSource: any[]) {
      let tem: any = {};
      dataSource.forEach((ele) => {
        tem[ele.menuId] = ele;
      });
      let temps = dataSource.map((ele: any) => {
        if (tem[ele.upMenuId]) {
          if (tem[ele.upMenuId].children) {
            tem[ele.upMenuId].children.push(ele);
          } else {
            tem[ele.upMenuId].children = [];
            tem[ele.upMenuId].children.push(ele);
          }
        }
        return ele;
      });
      let results: any[] = [];
      temps.forEach((ele) => {
        if (ele.lev === 1) {
          results.push(ele);
        }
      });
      return results;
    }

    axios
      .get(process.env.REACT_APP_MAIN_URL + "/sys/sys0101/getMenuByUser.exclude")
      .then((resp) => {
        const data = resp.data;
        if (data.status) {
          const temps = convertMenu(data.responseData);
          setMenus(temps);
          dispatch(setMenusData(data.responseData));
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  }, []);

  useEffect(() => {
    if (menus.length > 0) {
      let pathname = location.pathname;
      let menuActive = menus.find((parent: any) => parent.children.some((child: any) => child["url"] === pathname));
      setMenuActive(menuActive.menuId);
    }
  }, [menus]);

  return (
    // style={!sideBarShow ? { width: "70px" } : {}
    // <div classNameName={`app-menu navbar-menu ${!sideBarShow ? 'className-sidebar-width' : ''}`}>
    //     <div id="scrollbar">
    //         <div classNameName="container-fluid">
    //             <div id="two-column-menu">
    //             </div>
    //             <ul classNameName="navbar-nav" id="navbar-nav">
    //                 <NavGroup items={menus} showIcon={true} />
    //             </ul >
    //         </div >
    //     </div >
    //     <div classNameName="sidebar-background"></div>
    // </div >

    <div className="main-sidebar">
      <section className="sidebar position-relative">
        <div className="multinav">
          <div className="multinav-scroll">
            <ul className="sidebar-menu tree">
              <NavGroup items={menus} showIcon={true} menuActive={menuActive} />
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
